// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rating-stars>div{background:linear-gradient(to right,#f7931e var(--val),#b3b3b3 var(--val));-webkit-clip-path:polygon(50% 0,66% 31%,100% 36%,71% 60%,80% 94%,50% 76%,20% 94%,29% 60%,0 36%,34% 31%);clip-path:polygon(50% 0,66% 31%,100% 36%,71% 60%,80% 94%,50% 76%,20% 94%,29% 60%,0 36%,34% 31%);display:inline-block;height:var(--size);width:var(--size)}.rating-stars>div:not(:last-child){margin-right:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
